import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable, Select } from '@macs-frontend/decorators';
import { Store } from '@ngrx/store';
import { FormGroupState } from 'ngrx-forms';
import { Observable } from 'rxjs';
import * as authActions from '../../actions/auth.actions';
import * as fromAuth from '../../reducers';
import { KeycloakService } from '../../services/keycloak.service';

@Component({
  selector: 'md-login',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends BaseComponent implements OnDestroy, OnInit {
  @Select(fromAuth.getLoading)
  loading$!: Observable<boolean>;
  @Select(fromAuth.getToken)
  token$!: Observable<string>;
  @Select(fromAuth.getLoginForm)
  loginForm$!: Observable<FormGroupState<fromAuth.LoginForm>>;

  showPassword = false;

  constructor(
    readonly cdr: ChangeDetectorRef,
    readonly store$: Store<any>,
    private keycloak: KeycloakService,
  ) {
    super();
    makeSelectable(this, { cdr, store$ });
  }

  ngOnInit(): void {
    if (this.keycloak.enabled && !this.keycloak.authenticated) {
      this.keycloak.login();
    }
  }

  submit($event: any) {
    localStorage.setItem('token', $event.target.value);
  }

  login() {
    this.store$.dispatch(new authActions.Login());
  }

  ngOnDestroy() {
    this.store$.dispatch(new authActions.ResetLoginForm());
  }
}
